import React from 'react';
import { WidgetConfig } from './types';
import { DashboardDataContent } from './blocks/types';
import { widgetRegistry } from './registry';
import { WidgetEmptyState } from './design';
import { useAuthStore } from '../../store/authStore';
import type { ThemeMode } from '../../types';
import { FALLBACK_WIDGET_ICON } from './widgetIcons';

interface WidgetRendererProps {
  config: WidgetConfig;
  onDataSubmit?: (data: Record<string, unknown>) => void;
  readOnly?: boolean;
  dashboardData?: Record<string, unknown>;
  onDashboardDataChange?: (dataKey: string, newData: DashboardDataContent) => void;
  assignmentId?: string;
  widgetInstanceId?: string;
}

const WidgetRenderer: React.FC<WidgetRendererProps> = ({
  config,
  onDataSubmit,
  readOnly = false,
  dashboardData,
  onDashboardDataChange,
  assignmentId,
  widgetInstanceId,
}) => {
  const theme: ThemeMode = useAuthStore((s) => s.user?.theme) ?? 'light';
  const definition = widgetRegistry.get(config.type);

  if (!definition) {
    return (
      <WidgetEmptyState
        icon={FALLBACK_WIDGET_ICON}
        title={`Unknown widget type: ${config.type}`}
      />
    );
  }

  const RendererComponent = definition.Renderer;

  return (
    <div className="widget-container h-full flex flex-col">
      <div className="widget-content flex-1 overflow-auto">
        <RendererComponent
          config={config.config}
          onSubmit={onDataSubmit}
          readOnly={readOnly}
          dashboardData={dashboardData}
          onDataChange={onDashboardDataChange}
          theme={theme}
          assignmentId={assignmentId}
          widgetInstanceId={widgetInstanceId}
        />
      </div>
    </div>
  );
};

export default WidgetRenderer;
